import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    pure: true
})
export class TruncatePipe implements PipeTransform {

    transform(str: string, args: string): string {
        // Get limit argument (number of max chars)
        let limit = args ? parseInt(args, 10) : 2;
        let sentences = str.split(".");
        let more = (sentences.length > limit) ? "." : "";
        return sentences.splice(0, limit).join(".") + more;
    }
}

@Pipe({
    name: 'truncated',
    pure: true
})
export class TruncatedPipe implements PipeTransform {

    transform(str: string, args: string): boolean {
        // Get limit argument (number of max chars)
        let limit = args ? parseInt(args, 10) : 2;
        return (str.split(".").length > limit);
    }
}
